import React from "react";
import { Box, Button } from "@mui/material";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import { ImgContext } from "../Context/ImageCon";
import axios from "../axios";
function Audio() {
  const [audio, setAudio] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);

  let handleClick = (e) => {
    console.log(e.target.files[0]);
    setAudio(e.target.files[0]);
  };

  let handleQR = () => {
    axios
      .post(
        "image/",
        {
          name: audio.name,
          uploads: audio,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        setImg(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="section">
      {localStorage.getItem("access_token") ? (
        <div>
          <input
            accept=".mp3"
            className="input-file"
            style={{ display: "none" }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={handleClick}
          />
          <label htmlFor="raised-button-file">
            <Box className="UploadBox">
              <AudioFileIcon />
            </Box>
          </label>
        </div>
      ) : (
        "  Must be logged in to upload an audio"
      )}
      {audio ? audio.name : null}

      {audio ? (
        <Button
          onClick={handleQR}
          style={{ marginTop: "12%", marginLeft: "12%" }}
          variant="contained"
          color="primary"
        >
          Make QR
        </Button>
      ) : null}
    </div>
  );
}

export default Audio;
